import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import "../Dashboard.css";

import ReactDOMServer from "react-dom/server";

import Header from "../components/Header";
import Footer from "../components/Footer";
import ScrollToTop from "../components/ScrollTop";
import PreloadFetch from "../components/PreloadFetch";
import { ToastContainer, toast } from "react-toastify";

import moment from "moment";
import "moment/locale/es";
moment.locale("es");

import { ImEye, ImFilePdf, ImSearch, ImArrowUpRight2 } from "react-icons/im";
import { useAuth } from "../provider/authProvider";
import { Link, useNavigate } from "react-router-dom";

import ResponsivePagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic.css";

import PhoneLoader from "../components/loader/PhoneLoader";

function CreditsPage(props) {
    const { user, rol } = useAuth();
    const navigate = useNavigate();

    const searchRef = useRef();

    const [loading, setLoading] = useState(false);
    const [preload, setPreload] = useState(false);

    const [listCredits, setListCredits] = useState();
    let [numPages, setNumPages] = useState(0);
    const [paginationHtml, setPaginationHtml] = useState([]);
    const [selectPagination, setSelectPagination] = useState(1);
    const [showPagination, setShowPagination] = useState(true);
    const [selectFilterState, setSelectFilterState] = useState(0);
    // const [filterState, setFilterState] = useState([])
    const [arrCountFilter, setArrCountFilter] = useState([]);

    const getCredits = async () => {
        try {
            setLoading(true);
            const credits = await axios({
                method: "get",
                url: process.env.REACT_APP_API + "/credits",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    user,
                },
            });
            const resData = credits.data;
            setListCredits(resData.data);
            setNumPages(resData.numPages);
            setArrCountFilter(resData.arrCountFilter);
        } catch (err) {
            console.log(err);
            return false;
        } finally {
            setLoading(false);
        }
    };

    const followToEnroll = (linkNumber, dni) => {
        localStorage.setItem("linkNumber", linkNumber);
        localStorage.setItem("dniEnroll", dni);
        navigate("/evaluation-system/enroll-phone");
    };

    const getStatedevice = async () => {
        let pathApi =
            process.env.REACT_APP_API + process.env.REACT_APP_DEVICE_DETAILS;
        let dataID = getParams.id;

        const stateDevice = await axios({
            method: "POST",
            url: pathApi,
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
                user,
                "Content-Type": "application/json",
            },
            data: { dataID },
            withCredentials: false,
            credentials: "include",
        });
        const resData = stateDevice.data;
        if (resData.msg == "exito") {
            setStateDevice(resData.statusLock);
        }
    };

    const getNameDate = (datePass) => {
        const dateSplit = datePass.split(" ");
        const dateSplitOne = dateSplit[0];
        const dateSplitTwo = dateSplit[1];
        const splitDateOne = dateSplitOne.split("-");
        const structureDate =
            splitDateOne[2] +
            "-" +
            splitDateOne[1] +
            "-" +
            splitDateOne[0] +
            " " +
            dateSplitTwo;
        const formatDate = structureDate;
        const dayNames = [
            "Lunes",
            "Martes",
            "Miercoles",
            "Jueves",
            "Viernes",
            "sábado",
            "Domingo",
        ];
        let date = "";
        if (splitDateOne[0].length != 4) {
            date = new Date(formatDate);
        } else {
            date = new Date(datePass);
        }
        return dayNames[date.getDay() - 1];
    };

    const searchEngine = async (event) => {
        let searchName = event.target.value;
        let idPagination = selectPagination;
        if (searchName.length > 0) {
            setShowPagination(false);
        } else {
            setShowPagination(true);
            setSelectFilterState(0);
        }
        let pathApi = process.env.REACT_APP_API + process.env.REACT_APP_SEARCH;
        const insertCredit = await axios({
            method: "POST",
            url: pathApi,
            headers: {
                "Content-Type": "application/json",
            },
            data: { searchName, idPagination },
        });
        const resData = insertCredit.data;
        if (resData.msg == "success") {
            setListCredits(resData.data);
        }
    };

    const paginationEngine = () => {
        let html = [];
        numPages = 20;
        for (let page = 1; page <= numPages; page++) {
            if (page == selectPagination) {
                html.push(
                    <li key={page} onClick={getDataOfPagination} className="select">
                        {page}
                    </li>,
                );
            } else {
                html.push(
                    <li key={page} onClick={getDataOfPagination}>
                        {page}
                    </li>,
                );
            }
        }
        setPaginationHtml(html);
    };

    const getDataOfPagination = async (event) => {
        let idPagination = parseInt(event);
        let filterState = selectFilterState;
        let pathApi =
            process.env.REACT_APP_API + process.env.REACT_APP_PAGINATION_DATA;
        const insertCredit = await axios({
            method: "POST",
            url: pathApi,
            headers: {
                "Content-Type": "application/json",
            },
            data: { idPagination, filterState },
        });
        const resData = insertCredit.data;
        if (resData.msg == "success") {
            setListCredits(resData.data);
            setSelectPagination(idPagination);
        }
    };

    const filterChangeFunc = async (state) => {
        let idPagination = 1;
        let pathApi = process.env.REACT_APP_API + process.env.REACT_APP_FILTER_DATA;
        setLoading(true);
        const insertCredit = await axios({
            method: "POST",
            url: pathApi,
            headers: {
                "Content-Type": "application/json",
            },
            data: { idPagination, statusID: state },
        });
        console.log(insertCredit);
        const resData = insertCredit.data;
        if (resData.msg == "success") {
            setSelectPagination(1);
            setListCredits(resData.data);
            setSelectFilterState(state);
            setNumPages(resData.numPages);
            setLoading(false);
        }
    };

    const changeDate = (date) => {
        let firtsPaymentTransformOne = date.split("/");
        let constructDate =
            firtsPaymentTransformOne[2] +
            "-" +
            firtsPaymentTransformOne[1] +
            "-" +
            firtsPaymentTransformOne[0];
        return constructDate;
    };

    const exportxlsx = async () => {
        let state = 1;
        let pathApi = process.env.REACT_APP_API + process.env.REACT_APP_EXPORT_DATA;
        const insertCredit = await axios({
            method: "POST",
            url: pathApi,
            headers: {
                "Content-Type": "application/json",
            },
            data: { state },
        });
        const resData = insertCredit.data;
        if (resData.msg == "success") {
            let msg = "DESCARGADO CON ÉXITO";
            toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            let urlExcel = process.env.REACT_APP_API + "/data-files" + resData.data;
            let link = document.createElement("a");
            link.href = urlExcel;
            link.download = true;
            link.click();
        } else {
            let msg = "NO TIENES PERMISO PARA ESTA ACCIÓN";
            toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
    };

    const generateDayName = (date) => {
        try {
            let newDate = date;
            if (date) {
                let splitDate = date.split(" ");
                let splitMiddleDash = splitDate[0].split("-");

                if (splitMiddleDash[0].length <= 2) {
                    newDate =
                        splitMiddleDash[2] +
                        "-" +
                        splitMiddleDash[1] +
                        "-" +
                        splitMiddleDash[0] +
                        " " +
                        splitDate[1];
                }
            }
            return moment(newDate).format("dddd");
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        localStorage.removeItem("linkNumber");
        localStorage.removeItem("dniEnroll");
        getCredits();
    }, []);

    useEffect(() => {
        paginationEngine();
    }, [numPages, selectPagination, selectFilterState]);

    return (
        <div>
            {preload && <PreloadFetch />}
            {loading && <PhoneLoader />}
            <ScrollToTop />

            <Header user={user} namePage={props.namePage} />

            <section className="sectionBody sectionBodyCredits">
                <div className="containerCustom containerBody">
                    <div className="blockBody">
                        <div className="boxSearchEngine">
                            <div>
                                <ImSearch />
                                <input
                                    ref={searchRef}
                                    onInput={(event) => searchEngine(event)}
                                    type="text"
                                />
                            </div>
                        </div>

                        <div className="ImArrowUpRight2Parent">
                            <Link className="arrowUpRight" to={"../fee-stats"}>
                                <span>Estadisticas</span>
                                <ImArrowUpRight2 />
                            </Link>

                            <Link className="arrowUpRight semaforoBoton" to={"../semaforo"}>
                                <span>Semaforo</span>
                                <ImArrowUpRight2 />
                            </Link>
                        </div>

                        <h3>Listado de Prestamos</h3>

                        <div className="filterHeader">
                            <div className="filterOptions ff">
                                {arrCountFilter && arrCountFilter[1] > 0 && (
                                    <div
                                        onClick={() => filterChangeFunc(1)}
                                        className={
                                            selectFilterState == 1
                                                ? "select filterOptionsItem filterOptionsItem1"
                                                : "filterOptionsItem filterOptionsItem1"
                                        }
                                    >
                                        Activos({arrCountFilter[1]})
                                    </div>
                                )}
                                {arrCountFilter && arrCountFilter[5] > 0 && (
                                    <div
                                        onClick={() => filterChangeFunc(5)}
                                        className={
                                            selectFilterState == 5
                                                ? "select filterOptionsItem filterOptionsItem7"
                                                : "filterOptionsItem filterOptionsItem7"
                                        }
                                    >
                                        Vence Mañana({arrCountFilter[5]})
                                    </div>
                                )}
                                {arrCountFilter && arrCountFilter[2] > 0 && (
                                    <div
                                        onClick={() => filterChangeFunc(2)}
                                        className={
                                            selectFilterState == 2
                                                ? "select filterOptionsItem filterOptionsItem2"
                                                : "filterOptionsItem filterOptionsItem2"
                                        }
                                    >
                                        Vence Hoy({arrCountFilter[2]})
                                    </div>
                                )}
                                {arrCountFilter && arrCountFilter[3] > 0 && (
                                    <div
                                        onClick={() => filterChangeFunc(3)}
                                        className={
                                            selectFilterState == 3
                                                ? "select filterOptionsItem filterOptionsItem3"
                                                : "filterOptionsItem filterOptionsItem3"
                                        }
                                    >
                                        Bloqueados({arrCountFilter[3]})
                                    </div>
                                )}
                                {arrCountFilter && arrCountFilter[4] > 0 && (
                                    <div
                                        onClick={() => filterChangeFunc(4)}
                                        className={
                                            selectFilterState == 4
                                                ? "select filterOptionsItem filterOptionsItem4"
                                                : "filterOptionsItem filterOptionsItem4"
                                        }
                                    >
                                        Finalizados({arrCountFilter[4]})
                                    </div>
                                )}
                                {arrCountFilter && arrCountFilter[0] > 0 && (
                                    <div
                                        onClick={() => filterChangeFunc(0)}
                                        className={
                                            selectFilterState == 0
                                                ? "select filterOptionsItem filterOptionsItem5"
                                                : "filterOptionsItem filterOptionsItem5"
                                        }
                                    >
                                        All({arrCountFilter[0]})
                                    </div>
                                )}
                                {arrCountFilter && (
                                    <div
                                        onClick={() => filterChangeFunc(8)}
                                        className={
                                            selectFilterState == 8
                                                ? "select filterOptionsItem filterOptionsItem8"
                                                : "filterOptionsItem filterOptionsItem8"
                                        }
                                    >
                                        List All({arrCountFilter[0]})
                                    </div>
                                )}
                                {rol === "1" && (
                                    <div
                                        onClick={() => exportxlsx()}
                                        className={"filterOptionsItem filterOptionsItem6"}
                                    >
                                        Export XLSX
                                    </div>
                                )}
                            </div>

                            {showPagination && (
                                <div className="boxPagination boxPaginationTop">
                                    <ResponsivePagination
                                        current={selectPagination}
                                        total={numPages}
                                        onPageChange={getDataOfPagination}
                                    />
                                </div>
                            )}
                        </div>

                        <div className="parentTable">
                            <table>
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Estado</th>
                                        <th>Fecha de Inscripción</th>
                                        <th>FM</th>
                                        <th>Días Vencidos</th>
                                        <th>Total cuotas</th>
                                        <th>Valor Cuota</th>
                                        <th>Cuotas Pagadas</th>
                                        <th>Cuotas Vencidas</th>
                                        <th>Monto Vencido</th>
                                        <th>Sede</th>
                                        <th>Seller</th>
                                        <th>DNI</th>
                                        <th>Nombre Completo</th>
                                        <th>Celular</th>
                                        <th>Nombre de Equipo</th>
                                        {/*<th>Tipo de venta</th>*/}
                                        <th>Estado de Inscripción</th>
                                        {/* <th>Día de Incripción</th> */}
                                        <th>Enrolar</th>
                                        <th>Contrato</th>
                                        <th>Anexo 2</th>
                                        <th>Anexo 3</th>
                                        {rol !== "3" && <th>Ver</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {listCredits &&
                                        listCredits.map((item, index) => {
                                            // === Parse del schedule ===
                                            const schedule = JSON.parse(item.daysPayment || "[]");

                                            // 1) Primera cuota impaga
                                            const firstUnpaid = schedule.find(
                                                (q) => Number(q.state) === 0,
                                            );

                                            // 2) constructDate desde primera impaga (para tu columna Estado)
                                            let constructDate = null;
                                            if (firstUnpaid?.date) {
                                                constructDate = moment(
                                                    firstUnpaid.date,
                                                    "DD/MM/YYYY",
                                                ).format("YYYY-MM-DD");
                                            }

                                            // 3) Cuotas vencidas a hoy (impagas con fecha pasada)
                                            const today = moment().startOf("day");
                                            const pastDueInstalments = schedule.filter(
                                                (q) =>
                                                    Number(q.state) === 0 &&
                                                    today.isAfter(moment(q.date, "DD/MM/YYYY"), "day"),
                                            );

                                            // 4) Días vencidos: SOLO si fr_state_filter === 3 (vencido)
                                            let daysInArrears = 0;
                                            if (Number(item.stateFilter) === 3 && firstUnpaid?.date) {
                                                const firstDue = moment(
                                                    firstUnpaid.date,
                                                    "DD/MM/YYYY",
                                                ).startOf("day");
                                                if (today.isAfter(firstDue)) {
                                                    daysInArrears = today.diff(firstDue, "days");
                                                }
                                            }

                                            const duesPaid = schedule.filter(
                                                (q) => Number(q.state) === 1,
                                            );

                                            const mm = moment().format();
                                            const mms = mm.split("T");

                                            return (
                                                <tr key={index}>
                                                    <td>{item.id}</td>
                                                    <td className="tdStateDevice">
                                                        {constructDate == null ? (
                                                            <>
                                                                <span className="cuatro blueState">
                                                                    Finalizado
                                                                </span>
                                                            </>
                                                        ) : constructDate && mms[0] == constructDate ? (
                                                            <>
                                                                <span className="dos orangeState">
                                                                    Vence Hoy
                                                                </span>
                                                            </>
                                                        ) : constructDate &&
                                                            moment(moment()).isBefore(
                                                                moment(constructDate),
                                                            ) ? (
                                                            <>
                                                                <span className="uno greenState">Activo</span>
                                                            </>
                                                        ) : constructDate &&
                                                            moment(moment()).isAfter(
                                                                moment(constructDate),
                                                            ) ? (
                                                            <>
                                                                <span className="dos redState">Bloqueado</span>
                                                            </>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </td>
                                                    <td>{item.contractDate}</td>
                                                    <td className="tdStateDevice tdStateDeviceFM">
                                                        {(() => {
                                                            switch (Number(item.fmStateFilter)) {
                                                                case 1:
                                                                case 2:
                                                                case 5:
                                                                    return (
                                                                        <span
                                                                            onClick={() =>
                                                                                navigate(`/fm/${item.fmId}`)
                                                                            }
                                                                            className="uno greenState"
                                                                        >
                                                                            Activo
                                                                        </span>
                                                                    );
                                                                case 3:
                                                                    return (
                                                                        <span
                                                                            onClick={() =>
                                                                                navigate(`/fm/${item.fmId}`)
                                                                            }
                                                                            className="dos redState"
                                                                        >
                                                                            Vencido
                                                                        </span>
                                                                    );
                                                                case 4:
                                                                    return (
                                                                        <span
                                                                            onClick={() =>
                                                                                navigate(`/fm/${item.fmId}`)
                                                                            }
                                                                            className="cuatro blueState"
                                                                        >
                                                                            Finalizado
                                                                        </span>
                                                                    );
                                                                default:
                                                                    return (
                                                                        <span className="cero grayState">
                                                                            Sin FM
                                                                        </span>
                                                                    );
                                                            }
                                                        })()}
                                                    </td>
                                                    <td>{`${daysInArrears} ${daysInArrears === 1 ? "Dia" : "Dias"}`}</td>
                                                    {/* <td>{
                                                    firstUnpaid ? firstUnpaid.date : 'Finalizado'} <br />
                                                    <p className="tableDayName">{generateDayName(item.contractDate)}</p>
                                                </td> */}
                                                    <td>{schedule.length}</td>
                                                    <td>S/. {parseFloat(item.fee).toFixed(2)}</td>
                                                    <td>{duesPaid.length}</td>
                                                    <td>{pastDueInstalments.length}</td>
                                                    <td>
                                                        S/.{" "}
                                                        {parseFloat(
                                                            pastDueInstalments.length * item.fee,
                                                        ).toFixed(2)}
                                                    </td>
                                                    <td>{item.sedeName}</td>
                                                    <td>{item.name + " " + item.paternalAP}</td>
                                                    <td>{item.dni}</td>
                                                    <td>{item.fullName + " " + item.lastName}</td>
                                                    <td>{item.phoneNumber}</td>
                                                    <td>{item.phoneName}</td>
                                                    {/* <td>{item.type == 'f' ? 'Crédito' : 'FD'}</td> */}
                                                    <td>
                                                        {item.enrollState == "0" ? "Cotizado" : "Enrolado"}
                                                    </td>
                                                    {/* <td></td> */}
                                                    <td>
                                                        {item.enrollState === "0" &&
                                                            item.paymentState !== "3" && (
                                                                <div
                                                                    className="buttonFollowToEnroll"
                                                                    onClick={() =>
                                                                        followToEnroll(item.linkNumber, item.dni)
                                                                    }
                                                                >
                                                                    Seguír
                                                                </div>
                                                            )}
                                                    </td>
                                                    <td>
                                                        {item.enrollState === "1" && (
                                                            <a
                                                                target="_blank"
                                                                download={true}
                                                                href={
                                                                    process.env.REACT_APP_API +
                                                                    "/data-files/" +
                                                                    item.uploadName +
                                                                    "/" +
                                                                    item.contract
                                                                }
                                                            >
                                                                <ImFilePdf />
                                                            </a>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {item.enrollState === "1" && (
                                                            <a
                                                                target="_blank"
                                                                download={true}
                                                                href={
                                                                    process.env.REACT_APP_API +
                                                                    "/data-files/" +
                                                                    item.uploadName +
                                                                    "/anexo-2.pdf"
                                                                }
                                                            >
                                                                <ImFilePdf />
                                                            </a>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {item.enrollState === "1" && (
                                                            <a
                                                                target="_blank"
                                                                download={true}
                                                                href={
                                                                    process.env.REACT_APP_API +
                                                                    "/data-files/" +
                                                                    item.uploadName +
                                                                    "/anexo-3.pdf"
                                                                }
                                                            >
                                                                <ImFilePdf />
                                                            </a>
                                                        )}
                                                    </td>

                                                    {rol !== "3" && (
                                                        <td>
                                                            <Link
                                                                className="aview"
                                                                to={"../credit/" + item.linkNumber}
                                                            >
                                                                <ImEye />
                                                            </Link>
                                                        </td>
                                                    )}
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </table>
                        </div>

                        {showPagination && (
                            <div className="boxPagination">
                                <ResponsivePagination
                                    current={selectPagination}
                                    total={numPages}
                                    onPageChange={getDataOfPagination}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}

export default CreditsPage;
